import { createAsyncThunk } from '@reduxjs/toolkit';
import Reducers from 'types/Reducers';
import fetcher from 'utilities/Fetcher';

const _url = '/player/quiz-group';

export const getQuizGroupWithQuizzes = createAsyncThunk(
  `${Reducers.QuizGroup}/Get quiz group with quizzes`,
  async (slug: string, { rejectWithValue }) => {
    const response: Response = await fetcher(`${_url}/${slug}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) return rejectWithValue((await response.json()) as any);
    return response.json();
  }
);
